import script from "./PotentialDonors.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialDonors.vue?vue&type=script&setup=true&lang=js"

import "./PotentialDonors.vue?vue&type=style&index=0&id=7701e576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7701e576"]])

export default __exports__